class QuantityInputV2 extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="number"]');
    if (!this.input) return;

    this.addEventListener('click', this.onClick.bind(this));
    this.input.addEventListener('change', this.debounce(() => this.commit(), 300));
  }

  onClick(event) {
    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    if (!minus && !plus) return;
    if (minus?.disabled || plus?.disabled) return;
    event.preventDefault();

    const current = parseInt(this.input.value, 10) || 0;
    const min = parseInt(this.input.min, 10) || 0;
    this.input.value = Math.max(min, current + (plus ? 1 : -1));
    this.commit();
  }

  commit() {
    const drawer = document.querySelector('cart-drawer-v2');
    const lineKey = this.dataset.lineKey;
    const value = parseInt(this.input.value, 10);
    if (!drawer || !lineKey || Number.isNaN(value)) return;
    drawer.updateQuantity(lineKey, value);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }
}

if (!customElements.get('quantity-input-v2')) customElements.define('quantity-input-v2', QuantityInputV2);
